<script>
import PrintParametersSettings from '../../printParameters/PrintParametersSettings.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PrintParametersSettings
  },
  props: {
    value: {
      type: Object
    },
    selectedOrganizationFromBackoffice: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      userSettings: {},
      notification: {
        state: false,
        timeout: 3000,
        success: {
          type: 'success',
          content: 'global.save.settings.success'
        },
        error: {
          type: 'error',
          content: 'global.save.settings.error'
        },
        loadingError: {
          type: 'error',
          content: 'global.settings.loading.error'
        },
      }
    }
  },
  computed: {
    ...mapGetters(['selectedOrganization']),
  },
  watch: {
    ['value.state']() {
      this.getUserSettings()
    }
  },
  methods: {
    async getUserSettings() {
      this.loading = true
      await this.$userService
        .getUserSettings({ userId: this.value.item.id })
        .then(userSettings => {
          this.userSettings = userSettings
        })
        .catch(() => {
          this.hasErrors = true
          this.showNotification(this.notification.loadingError)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async saveUserSettings() {
      this.saving = true;

      try {
        const isOrganizationAdmin = this.$props.selectedOrganizationFromBackoffice ||
          'isOrganizationAdmin' in this.$roles ||
          this.selectedOrganization.IsAdmin;

        if (isOrganizationAdmin) {
          this.userSettings.organizationId = this.$props.selectedOrganizationFromBackoffice
            ? +this.$props.selectedOrganizationFromBackoffice.id
            : +this.selectedOrganization.OrganizationId;
          this.userSettings.userId = this.value.item.id;

          this.userSettings = await this.$userService.saveUserSettingsAsAdmin(this.userSettings);
        } else {
          this.userSettings = await this.$userService.saveUserSettings(this.userSettings);
        }

        this.showNotification(this.notification.success);
      } catch (error) {
        this.showNotification(this.notification.error);
      } finally {
        this.saving = false;
      }
    },
    showNotification(notificationData) {
      this.notification.state = true
      this.notification.type = notificationData.type
      this.notification.content = this.$t(notificationData.content)
    }
  }
}
</script>
<template>
  <v-navigation-drawer v-model="value.state" width="540" temporary right app>
    <v-snackbar
      v-model="notification.state"
      :color="notification.type"
      :timeout="notification.timeout"
      multi-line
      top>
      <span v-html="notification.content" />
      <v-btn color="white" text @click="notification.state = false">
        <v-icon size="20">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card dense flat class="ml-4 mr-4">
      <v-card-title class="pl-0 pb-0">
        <b>{{ value.item.email }}</b>
      </v-card-title>
      <v-divider></v-divider>
      <DialogBaseText v-if="loading" class="text-center">
        <span class="mb-2 d-block">{{ $t('global.loading') }}</span>
        <v-progress-circular v-if="loading" color="primary" indeterminate />
      </DialogBaseText>
      <DialogBaseText v-else class="px-0">
        <PrintParametersSettings v-model="userSettings" fill-width />
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-spacer /><v-btn color="secondary" @click="value.state = false">{{
          $t('button.close') }}</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="loading"
          depressed
          @click.stop="saveUserSettings">
          {{ $t('button.save') }}</v-btn>
        <v-spacer />
      </DialogBaseActions>
    </v-card>
  </v-navigation-drawer>
</template>
